import { createFileRoute, notFound } from '@tanstack/react-router'

import { AchievementsContent } from '@/achievements/components/AchievementsContent/AchievementsContent'
import { ContentSkeleton } from '@/achievements/components/AchievementsContent/ContentSkeleton'
import { FEATURE_ACHIEVEMENTS } from '@/core/constants/features'
import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'

export const Route = createFileRoute('/_learning/_my-learning/achievements')({
  head: () => ({
    meta: [
      {
        title: buildPageTitle({
          titleKey: 'page-title-my-achievements',
        }),
      },
    ],
  }),
  beforeLoad: ({ context: { user } }) => {
    if (!user?.features.includes(FEATURE_ACHIEVEMENTS)) {
      throw notFound()
    }
  },
  component: AchievementsContent,
  pendingComponent: ContentSkeleton,
})
